import React, { useState } from "react";
import "./contactpage.css";
import CONFIG from "../src/config";
import axios from "axios";

const CommonContactForm = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormDatas] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    service: "",
    business: "",
  });
  const validateForm = () => {
    let formErrors = {};
    let formIsValid = true;

    // Name validation
    if (!formData.name) {
      formErrors.name = "Name is required";
      formIsValid = false;
    } else if (!/^[a-zA-Z\s]{3,}$/.test(formData.name.trim())) {
      formErrors.name =
        "Name must be at least 3 letters long and contain only alphabets";
      formIsValid = false;
    }

    if (!formData.email) {
      formErrors.email = "Email is required";
      formIsValid = false;
    } else {
      const emailPattern =
        /^[\w.-]+@(gmail\.com|yahoo\.com|cogniitec\.com|outlook\.com|hotmail\.com|icloud\.com|protonmail\.com|aol\.com)$/;

      if (!emailPattern.test(formData.email)) {
        formErrors.email =
          "Please enter valid email format(e.g., user@gmail.com)";
        formIsValid = false;
      }
    }

    if (!formData.phone) {
      formErrors.phone = "Phone number is required";
      formIsValid = false;
    } else if (!/^[6789]\d{9}$/.test(formData.phone)) {
      formErrors.phone = "Contact must be 10 digits (start with 6, 7, 8, or 9)";
      formIsValid = false;
    }

    // Subject validation
    if (!formData.subject) {
      formErrors.subject = "Subject is required";
      formIsValid = false;
    }

    // Service validation
    if (!formData.service) {
      formErrors.service = "Please select a service";
      formIsValid = false;
    }

    // Business validation
    if (!formData.business) {
      formErrors.business = "Please select a business group";
      formIsValid = false;
    }

    setErrors(formErrors);
    return formIsValid;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);

    try {
      console.log("Submitting Data:", formData);

      const response = await axios.post(
        `${CONFIG.BASE_URL}/Contact/submitforms`,
        formData
      );
      console.log("Response:", response.data);

      setFormDatas({
        name: "",
        email: "",
        phone: "",
        subject: "",
        service: "",
        business: "",
      });

      setErrors({});
    } catch (error) {
      console.error("Error:", error.response?.data || error.message); // Handle error
    }
  };

  return (
    <div className="common_contact_form">
      <div class="container">
        <div class="row col-xl-8 pb-0 m-auto g-5">
          <div className="group_contact">
            <form
              autoComplete="off"
              className="mt-0 pt-0"
              style={{ paddingTop: "0", marginTop: "0" }}
            >
              <div class="row form_inner g-4">
                <div class="text-center mx-auto" style={{ maxWidth: "800px" }}>
                  <h4 class=" text-white">Get In Touch</h4>
                  <p
                    className="mb-0s text-white"
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      width: "100%",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    For any inquiries or support, feel free to get in touch with
                    the Kovai Tech India Group today!
                  </p>
                </div>

                <div class="col-lg-12 col-xl-6">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control border-1"
                      id="name"
                      placeholder="Full Name"
                      name="name"
                      value={formData.name}
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-Z\s]$/.test(e.key) &&
                          e.key !== "Backspace"
                        ) {
                          e.preventDefault(); // Prevent numbers and special characters
                        }
                      }}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <div className="text-danger">{errors.name}</div>
                    )}

                    <label for="name">Your Name</label>
                  </div>
                </div>
                <div class="col-lg-12 col-xl-6">
                  <div class="form-floating">
                    <input
                      type="email"
                      class="form-control border-1"
                      id="email"
                      placeholder="Email Address"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}

                    <label for="email">Your Email</label>
                  </div>
                </div>
                <div className="col-lg-12 col-xl-6">
                  <div className="form-floating">
                    <div className="input-group" style={{ gap: "0px" }}>
                      {" "}
                      {/* Reduce space */}
                      {/* Country Code Dropdown */}
                      <select
                        className="form-select border-1"
                        id="countryCode"
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        style={{ maxWidth: "29%", paddingRight: "5px" }} // Adjust width & padding
                      >
                        <option value="+91">IN +91</option>
                        <option value="+1">US +1</option>
                        <option value="+44">UK +44</option>
                        <option value="+33">FR +33</option>
                        <option value="+49">DE +49</option>
                        <option value="+39">IT +39</option>
                        <option value="+34">ES +34</option>
                        <option value="+81">JP +81</option>
                        <option value="+86">CN +86</option>
                        <option value="+7">RU +7</option>
                        <option value="+55">BR +55</option>
                        <option value="+61">AU +61</option>
                        <option value="+27">ZA +27</option>
                        <option value="+62">ID +62</option>
                        <option value="+82">KR +82</option>
                        <option value="+92">PK +92</option>
                        <option value="+20">EG +20</option>
                        <option value="+31">NL +31</option>
                        <option value="+32">BE +32</option>
                        <option value="+46">SE +46</option>
                        <option value="+47">NO +47</option>
                        <option value="+48">PL +48</option>
                        <option value="+30">GR +30</option>
                        <option value="+90">TR +90</option>
                        <option value="+52">MX +52</option>
                        <option value="+63">PH +63</option>
                        <option value="+66">TH +66</option>
                        <option value="+65">SG +65</option>
                        <option value="+60">MY +60</option>
                        <option value="+64">NZ +64</option>
                        <option value="+351">PT +351</option>
                        <option value="+353">IE +353</option>
                        <option value="+354">IS +354</option>
                        <option value="+358">FI +358</option>
                        <option value="+420">CZ +420</option>
                        <option value="+421">SK +421</option>
                        <option value="+43">AT +43</option>
                        <option value="+45">DK +45</option>
                        <option value="+41">CH +41</option>
                        <option value="+376">AD +376</option>
                        <option value="+387">BA +387</option>
                        <option value="+359">BG +359</option>
                        <option value="+375">BY +375</option>
                        <option value="+385">HR +385</option>
                        <option value="+357">CY +357</option>
                        <option value="+372">EE +372</option>
                        <option value="+358">FI +358</option>
                        <option value="+370">LT +370</option>
                        <option value="+371">LV +371</option>
                        <option value="+373">MD +373</option>
                        <option value="+382">ME +382</option>
                        <option value="+377">MC +377</option>
                        <option value="+389">MK +389</option>
                        <option value="+356">MT +356</option>
                        <option value="+423">LI +423</option>
                        <option value="+380">UA +380</option>
                        <option value="+387">BA +387</option>
                        <option value="+374">AM +374</option>
                        <option value="+994">AZ +994</option>
                        <option value="+996">KG +996</option>
                        <option value="+998">UZ +998</option>
                        <option value="+964">IQ +964</option>
                        <option value="+962">JO +962</option>
                        <option value="+961">LB +961</option>
                        <option value="+965">KW +965</option>
                        <option value="+966">SA +966</option>
                        <option value="+971">AE +971</option>
                        <option value="+973">BH +973</option>
                        <option value="+974">QA +974</option>
                        <option value="+968">OM +968</option>
                        <option value="+213">DZ +213</option>
                        <option value="+216">TN +216</option>
                        <option value="+212">MA +212</option>
                        <option value="+254">KE +254</option>
                        <option value="+256">UG +256</option>
                        <option value="+255">TZ +255</option>
                        <option value="+250">RW +250</option>
                        <option value="+249">SD +249</option>
                        <option value="+231">LR +231</option>
                        <option value="+233">GH +233</option>
                        <option value="+234">NG +234</option>
                        <option value="+225">CI +225</option>
                        <option value="+221">SN +221</option>
                        <option value="+220">GM +220</option>
                        <option value="+507">PA +507</option>
                        <option value="+502">GT +502</option>
                        <option value="+503">SV +503</option>
                        <option value="+505">NI +505</option>
                        <option value="+506">CR +506</option>
                        <option value="+509">HT +509</option>
                        <option value="+591">BO +591</option>
                        <option value="+595">PY +595</option>
                        <option value="+598">UY +598</option>

                        {/* Add more countries as needed */}
                      </select>
                      {/* Phone Number Input */}
                      <input
                        type="tel"
                        className="form-control border-1 phone-input"
                        id="phone"
                        placeholder="Contact"
                        name="phone"
                        value={formData.phone}
                        style={{ height: "2.5rem", flex: "1" }} // Ensure proper spacing
                        onChange={handleChange}
                        maxLength="10"
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        } // Prevent non-numeric input
                      />
                    </div>

                    {/* Error Message */}
                    {errors.phone && (
                      <div className="text-danger">{errors.phone}</div>
                    )}
                  </div>
                </div>

                <div class="col-lg-12 col-xl-6">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control border-1"
                      id="subject"
                      placeholder="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-Z\s]$/.test(e.key) &&
                          e.key !== "Backspace"
                        ) {
                          e.preventDefault(); // Prevent numbers and special characters
                        }
                      }}
                    />
                    {errors.subject && (
                      <div className="text-danger">{errors.subject}</div>
                    )}

                    <label for="subject">Subject</label>
                  </div>
                </div>
                <div class="col-lg-12 col-xl-6">
                  <div class="form-floating">
                    <select
                      name="service"
                      className="form-select border-1"
                      value={formData.service}
                      onChange={handleChange}
                      placeholder="Select Our Service"
                    >
                      <option>Select Our Service</option>
                      <option>KTIG Groups</option>
                      <option>Banking solution</option>
                      <option>Finance solution</option>
                      <option>IT solution</option>
                      <option>Non-IT solution</option>
                      <option>Sales & Ecommerce</option>
                      <option>Training & Coaching</option>
                      <option>Marketing</option>
                    </select>
                    {errors.service && (
                      <div className="text-danger">{errors.service}</div>
                    )}
                  </div>
                </div>
                <div class="col-lg-12 col-xl-6">
                  <div class="form-floating">
                    <select
                      name="business"
                      className="form-select border-1"
                      value={formData.business}
                      onChange={handleChange}
                      placeholder="Group of Business"
                    >
                      <option class="optinglist">Group of Business</option>
                      <option class="optinglist">Finance</option>
                      <option class="optinglist">Banking</option>
                      <option class="optinglist">Course Training</option>
                      <option class="optinglist">IT/ITES Services</option>
                      <option class="optinglist">Content Writing</option>
                      <option class="optinglist">
                        Web design & Developemnt
                      </option>
                    </select>
                    {errors.business && (
                      <div className="text-danger">{errors.business}</div>
                    )}
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-xl-12 d-flex align-items-center justify-content-center justify-content-lg-end ">
                <div class="form_right btn-md-square rounded-circle">
                  <i class="fa fa-phone-alt fa-2x"></i>
                </div>
              </div>
            </form>

            {/* {contact form end} */}

            <div class="col-12">
              <div class="col-md-12 cantact_cta  w-100  col-lg-3 m-auto">
                <button class=" btn-grad btn w-100 py-3" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>

            {showAlert && (
              <div
                className="showalert"
                style={{
                  position: "fixed",
                  top: "10vh",
                  left: "50%",
                  transform: "translate(-50%, 0)",
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  padding: "12px 20px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                  zIndex: 9999, // Ensure it's on top
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  maxWidth: "90vw", // Adjust width for mobile
                  width: "320px",
                  textAlign: "center",
                  opacity: 1,
                  transition: "all 0.3s ease",
                  visibility: showAlert ? "visible" : "hidden",
                }}
              >
                <h2
                  style={{
                    marginTop: "10px",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}
                >
                  Success!
                </h2>
                <h3 style={{ fontSize: "14px", fontWeight: "400" }}>
                  Your Form is Successfully Submitted.
                </h3>
                <div style={{ marginTop: "15px" }}>
                  <button
                    onClick={() => setShowAlert(false)}
                    style={{
                      fontSize: "14px",
                      padding: "6px 12px",
                      backgroundColor: "#071c40",
                      color: "#fff",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonContactForm;
